import React, { useState, useCallback, useEffect } from "react";
import { memo } from "react";
import axiosInstance from "../../../redux/api";

const AdminRoles = ({ formik }) => {

    const [roles, setRoles] = useState([])

  const permissionMapping = { read: "1", write: "2", update: "3" };

  const handleChange = useCallback(
    (index, permissionType) => {
      const updatedRoles = roles.map((role, i) => {
        if (i === index) {
          const permissionValue = permissionMapping[permissionType];
          const isChecked = role.permission_level.includes(permissionValue);
          const updatedPermissions = isChecked
            ? role.permission_level.filter((perm) => perm !== permissionValue)
            : [...role.permission_level, permissionValue];
          return { ...role, permission_level: updatedPermissions };
        }
        return role;
      });
      setRoles(updatedRoles);

      // Update formik roles field
      const formattedPermissions = updatedRoles.map((role) => ({
        menu_id: role.id,
        permission_level: role.permission_level,
        is_active:role.permission_level.includes("1") ? true:false,
      }));
      formik.setFieldValue("permissions", formattedPermissions);
    },
    [roles, formik]
  );
console.log(formik.values.permissions, "the permissions")
  const handleGetMenuList = () =>{
    axiosInstance.get("/admin/menu_list")
      .then(res=>{
        if(res.data.status){
          setRoles(res.data.response)
        }
        
      })
      .catch(e=>console.log(e.message, "the error message"))
  }

  useEffect(()=>{
    handleGetMenuList();
  },[])

  return (
    <div className="table-sec">
      <h4 className="pb-3"> Admin Roles</h4>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Type</th>
            <th scope="col">Permissions</th>
          </tr>
        </thead>
        <tbody>
            {roles && roles.length != 0 && roles.map((role, index) => (
              <tr key={role.id}>
                <td>{role.title}</td>
                <td className="term-condition">
                  <input
                    type="checkbox"
                    checked={role.permission_level.includes("1")}
                    onChange={() => handleChange(index, "read")}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default memo(AdminRoles);
